import React from 'react';

function CTASection() {
    return (
        <section className="cta-section">
            <div className="section-content">
                <h2 className="section-title">
                    You Mastered Hospitality.<br />Let Us Handle <span className="highlight">Everything Else</span>.
                </h2>
                
                <div className="cta-pain-points">
                    <p className="cta-pain-point">
                        Stop losing $400K annually to Booking.com commissions.
                    </p>
                    <p className="cta-pain-point">
                        Stop hiring people who quit in 3 months.
                    </p>
                    <p className="cta-pain-point">
                        Stop being on call at your kid's birthday.
                    </p>
                </div>

                <div className="stats-card">
                    <p className="stats-card-title">
                        One Partner. Seven Services. Complete Relief.
                    </p>
                    <div className="stats-grid">
                        <div className="stat-item">
                            <div className="stat-value">95%</div>
                            <div className="stat-label">24hr Review SLA</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-value">98%+</div>
                            <div className="stat-label">OTA Parity Uptime</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-value">$47M+</div>
                            <div className="stat-label">Revenue Managed</div>
                        </div>
                    </div>
                </div>

                <div className="cta-group">
                    <a href="#contact" className="cta-primary">
                        Get Your Free Property Audit
                    </a>
                    <a href="#contact" className="cta-secondary">
                        Book Strategy Call (15 min)
                    </a>
                </div>
            </div>
        </section>
    );
}

export default CTASection;

